"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmojiAddIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("../SVGBox");
var RegularSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 18 18" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M16.5448 6.33333C16.8396 7.16741 17 8.06497 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C9.93503 1 10.8326 1.16041 11.6667 1.45522", stroke: "black", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M8.99996 15C11.2557 15 13.1844 13.5996 13.964 11.6207C14.3688 10.593 13.4379 9.66666 12.3333 9.66666H5.66663C4.56206 9.66666 3.63108 10.593 4.03594 11.6207C4.81552 13.5996 6.74419 15 8.99996 15Z", fill: "white", stroke: "black" }, void 0),
            jsx_runtime_1.jsx("ellipse", { cx: "6.33329", cy: "7", rx: "0.666667", ry: "0.666667", fill: "black" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "11.6667", cy: "7", r: "0.666667", fill: "black" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M8.98403 14.9333C9.92153 14.9333 10.8025 14.6914 11.568 14.2667L10.7886 13.965C9.62751 13.5157 8.34055 13.5157 7.17947 13.965L6.40002 14.2667C7.16552 14.6914 8.04653 14.9333 8.98403 14.9333Z", fill: "white", stroke: "black" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M14.6667 1V5.66667", stroke: "black", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M12.3334 3.33334L17 3.33334", stroke: "black", strokeLinecap: "round" }, void 0)] }), void 0));
};
var EmojiAddIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.EmojiAddIcon = EmojiAddIcon;
//# sourceMappingURL=EmojiAddIcon.js.map